module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/app-icon-c85b98a71c20ffd817a29c28470c7b6b.svg";